import { useContext } from 'react';
import { OnStartWarningHook } from '../../../../_Common/Const/Rutiner';
import AnvandarInstallningarQuery from '../Queries/HasAnyBokfgruppQuery.gql';
import {
  HasAnyBokfgruppQuery,
  HasAnyBokfgruppQueryVariables,
} from '../Queries/_QueryTypes/HasAnyBokfgruppQuery';
import { useQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

export const useKonteringarOnStartWarningHook: OnStartWarningHook =
  isLoggedIn => {
    const activeDatabase = useContext(ActiveDatabaseContext);
    const { data, loading } = useQuery<
      HasAnyBokfgruppQuery,
      HasAnyBokfgruppQueryVariables
    >(AnvandarInstallningarQuery, {
      variables: {
        dbname: activeDatabase.activeDatabase || '',
      },
      skip: !activeDatabase.activeDatabase || !isLoggedIn,
    });

    return {
      loading: loading,
      ok: !loading && Boolean(data?.me?.[0]?.hasAnyBokfgrupp),
      warningText:
        'Du är ej behörig till någon bokföringsgrupp och kan därför inte se några verifikationsrader.',
    };
  };
